import React from 'react'
import ReactDOM from 'react-dom'
import Root from './Root'

export default () => {
    ReactDOM.render(<Root />, document.getElementById('react-root'))
}
